import { makeStyles } from "@material-ui/core";

const MuiStylesAppointmentSuccessDialog = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    maxWidth: "500px",
    margin: "16px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  dialogHeader: {
    padding: "20px 24px 16px",
    backgroundColor: "#f0fff4",
    borderBottom: "1px solid #c6f6d5",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2f855a",
    margin: 0,
  },
  closeButton: {
    minWidth: "auto",
    padding: "8px",
    color: "#38a169",
    "&:hover": {
      backgroundColor: "#c6f6d5",
    },
  },
  dialogContent: {
    padding: "0",
    backgroundColor: "#f0fff4",
    minHeight: "400px",
  },
  successIconContainer: {
    padding: "24px",
    textAlign: "center",
    backgroundColor: "white",
    borderBottom: "1px solid #c6f6d5",
  },
  successIcon: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#c6f6d5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 16px",
  },
  successIconSvg: {
    fontSize: "48px",
    color: "#38a169",
  },
  successTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2f855a",
    marginBottom: "8px",
  },
  successMessage: {
    fontSize: "14px",
    color: "#4a5568",
    lineHeight: "1.5",
  },
  detailsCard: {
    margin: "20px 24px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    backgroundColor: "white",
  },
  detailsTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "16px",
    paddingBottom: "8px",
    borderBottom: "2px solid #e2e8f0",
  },
  dateTimeSection: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  dateTimeIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#e6fffa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    color: "#38b2ac",
  },
  dateTimeInfo: {
    flex: 1,
  },
  appointmentDate: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#2d3748",
    marginBottom: "2px",
  },
  appointmentTime: {
    fontSize: "14px",
    color: "#718096",
  },
  businessSection: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px",
  },
  businessIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#ebf8ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    color: "#3182ce",
  },
  businessInfo: {
    flex: 1,
  },
  businessLabel: {
    fontSize: "12px",
    color: "#718096",
    marginBottom: "2px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  businessName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "2px",
  },
  businessAddress: {
    fontSize: "12px",
    color: "#718096",
  },
  professionalSection: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px",
  },
  professionalIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#fef5e7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    color: "#dd6b20",
  },
  professionalInfo: {
    flex: 1,
  },
  professionalLabel: {
    fontSize: "12px",
    color: "#718096",
    marginBottom: "8px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  professionalDetails: {
    display: "flex",
    alignItems: "center",
  },
  professionalAvatar: {
    width: "36px",
    height: "36px",
    marginRight: "12px",
    border: "2px solid #e2e8f0",
  },
  professionalName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#2d3748",
    marginBottom: "2px",
  },
  serviceInfo: {
    fontSize: "13px",
    color: "#4a5568",
    marginBottom: "2px",
  },
  priceTag: {
    fontSize: "11px",
    color: "#718096",
    fontWeight: "500",
  },
  nextStepsSection: {
    backgroundColor: "#f7fafc",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
  },
  nextStepsTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#2d3748",
    marginBottom: "8px",
  },
  stepsList: {
    "& > *": {
      marginBottom: "4px",
    },
  },
  stepItem: {
    fontSize: "12px",
    color: "#4a5568",
    lineHeight: "1.4",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "20px 24px",
    backgroundColor: "white",
    borderTop: "1px solid #c6f6d5",
  },
  viewReservationsButton: {
    backgroundColor: "#38a169",
    color: "white",
    padding: "14px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#2f855a",
    },
  },
  goHomeButton: {
    backgroundColor: "transparent",
    color: "#38a169",
    border: "2px solid #38a169",
    padding: "14px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#38a169",
      color: "white",
    },
  },
}));

export default MuiStylesAppointmentSuccessDialog;


